---
type: guest
cover: https://media.codingcat.dev/image/upload/v1698251838/main-codingcatdev-photo/podcast-guest/b5mz5aTv_400x400.png
name: pngwn
published: published
slug: pngwn
start: January 1, 2000
socials:
  github: https://github.com/pngwn
  twitter: https://twitter.com/evilpingwin
---

## About

🐧 brrrrrrr!
